import axios, { AxiosResponse } from "axios";
import { IDocksUser } from "../models/user";

export const getUser = async (id: string): Promise<AxiosResponse<IDocksUser>> => {
    return axios.get(`/docks/user/${id}`);
};

export const changeUser = async (user: IDocksUser): Promise<AxiosResponse<IDocksUser>> => {
    return axios.patch("/docks/user", user);
};
